export const iconFontAwesomeClothingFashionShoePrints = (
	<i className="fa-solid fa-shoe-prints"></i>
);
